module.exports = __webpack_public_path__ + "img/part4-uIcon10.73614df9.png";